import { M } from '../tokens/theme.js';
/**
 * Portal Manta · capitulos.js
 * Extraído de App.jsx v29.2 modular
 */

export const CAPITULOS_M = [
  {n:0, romano:'⓪',  titulo:'Início',       cor:M.accent,      ids:['sumario']},
  {n:1, romano:'I',   titulo:'Explorar',     cor:M.title,       ids:['lote-3','lote-4','lote-5','conhecimento']},
  {n:2, romano:'II',  titulo:'Criar',        cor:M.heading,     ids:['novo-estudo','add-base','aluci-guard']},
  {n:3, romano:'III', titulo:'Configurar',   cor:M.accentDark,  ids:['criterio','agentes']},
  {n:4, romano:'IV',  titulo:'Ajuda',        cor:M.blue,        ids:['ajuda']},
];

export const CAP_BY_ID = CAPITULOS_M.reduce((acc, cap) => {
  cap.ids.forEach(id => { acc[id] = cap; });
  return acc;
}, {});

export const NUM_BY_ID = {
  // ⓪ Sumário
  'sumario':         '00',
  // I · EXPLORAR
  'lote-3':          '01',
  'lote-4':          '02',
  'lote-5':          '03',
  'conhecimento':    '04',
  'kb-curada':       '04.1',
  'kpis-globais':    '04.2',
  'orcamentacao':    '04.3',
  // II · CRIAR
  'novo-estudo':     '05',
  'add-base':        '06',
  'aluci-guard':     '06.5',
  // III · CONFIGURAR
  'criterio':        '07',
  'agentes':         '08',
  // IV · AJUDA
  'ajuda':           '09',
  'tour':            '09.1',
  'glossario':       '09.2',
};

export const TOUR_M = [
  {n:1,  cap:'⓪', id:'sumario',      titulo:'Sumário & Header',
    mostra:'Identificação do projeto, cliente, contrato, versão e localização master no SharePoint.',
    porQue:'Padrão 12.4 — todo artefato Manta carrega header de rastreabilidade. Sem ele, o número soltinho perde valor.'},
  {n:2,  cap:'I', id:'lote-3',       titulo:'Lote 3 · BR-376',
    mostra:'Análise técnica do Lote 3 — extensão, OAEs, sondagens, orçamento paramétrico Manta vs PR Vias.',
    porQue:'Primeiro dos 3 lotes oficiais. Estrutura idêntica aos demais para comparação direta.'},
  {n:3,  cap:'I', id:'lote-4',       titulo:'Lote 4 · PR-323',
    mostra:'Lote do Norte do PR · Maringá-Umuarama · 55% rural · 30% urbano.',
    porQue:'Maior densidade urbana entre os 3. Útil para calibrar drivers de marginais e ciclovias.'},
  {n:4,  cap:'I', id:'lote-5',       titulo:'Lote 5 · BR-369',
    mostra:'Lote sinuoso · Cornélio Procópio-Apucarana · 30% serra.',
    porQue:'Maior componente de OAEs por km. Calibra drivers geotécnicos e estruturais.'},
  {n:5,  cap:'I', id:'conhecimento', titulo:'Conhecimento Consolidado',
    mostra:'Fusão das antigas KB Curada (qualitativo) + KPIs Globais (quantitativo) + Orçamentação Consolidada (financeiro) em 3 abas.',
    porQue:'Mesma informação vista por 3 ângulos — antes estava espalhada em 3 itens de menu.'},
  {n:6,  cap:'II', id:'novo-estudo', titulo:'Novo Estudo (wizard)',
    mostra:'Wizard de 6 etapas para estimar orçamento de novo lote por similaridade.',
    porQue:'KPIs → Escopo → Cosseno → Confirmação → Geração → Salvar. Acompanhado pelo Agente Guia (Seção 13).'},
  {n:7,  cap:'II', id:'add-base',    titulo:'Adicionar à Base',
    mostra:'Formulário para incluir caso real (orçamento histórico) na base de similaridade.',
    porQue:'Cada caso adicionado melhora a precisão futura do wizard. Persistência local + export JSON.'},
  {n:8,  cap:'II', id:'aluci-guard', titulo:'Aluci-Guard · Anti-alucinação',
    mostra:'Validador anti-alucinação Pacote A (Cap 16.3). Detecta normas ABNT/leis fabricadas, URLs/DOIs inventados, SICRO inexistentes.',
    porQue:'Audita textos antes de virarem documento Manta. Registry com 44 ABNT + 31 leis + 20 SICRO. v0.2.0.'},
  {n:9,  cap:'III', id:'criterio',   titulo:'Critério de Similaridade',
    mostra:'Tuning do cosseno: peso físico × contexto, dimensões consideradas (densidades, chuva, contexto urbano).',
    porQue:'Configuração centralizada do motor de matching. Mudanças aqui afetam todos os Novos Estudos.'},
  {n:10, cap:'III', id:'agentes',    titulo:'Catálogo de Agentes',
    mostra:'10 agentes em 5 categorias + 2 pipelines (analiseLote, novoOrcamento). Orquestrador unificado.',
    porQue:'Camada Skills/Agentes (PK_07 · 02.4). Cada agente é função pura reaproveitável.'},
  {n:11, cap:'IV', id:'ajuda',       titulo:'Ajuda · Tour & Glossário',
    mostra:'Repositório do tour (este painel) + glossário de termos técnicos do estudo.',
    porQue:'Padrão 12.5 · todo portal Manta tem tour navegável.'},
];
